<ng-container *transloco="let t">
  <section>
    <div class="grid grid-cols-2 gap-6">
      <div>
        <div class="mb-3">
          <nz-alert
            *ngIf="actionMessage.display && actionMessage.isAdd"
            class="mt-2"
            [nzType]="actionMessage.type"
            [nzMessage]="actionMessage.message"
            nzShowIcon
            nzCloseable></nz-alert>
        </div>
        <div class="flex justify-between mb-3">
          <h6>{{ t('settings.preferences.tourCosting.predefinedCost.title') }}</h6>
          <button
            nz-button
            nzType="primary"
            (click)="
              addEditPredefinedCosting(
                SETTINGS.PREDEFINED_COST_MODE.NEW,
                this.predefinedCosting
              )
            "
            class="flex items-center justify-center gap-2">
            <lucide-icon name="plus" class="icon-size"></lucide-icon>
            {{ t('settings.common.add') }}
          </button>
        </div>
        <div *ngFor="let pre of this.predefinedCosting; let i = index">
          <div class="bg-white border border-gray rounded-2xl p-4 mb-3">
            <div class="flex flex-row justify-between">
              <h5>{{ pre.title }}</h5>
              <div>
                <nz-tag [nzColor]="'purple'">{{
                  pre.costCalSymbol ===
                  SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT
                    ? t('settings.preferences.tourCosting.predefinedCost.type.percentage')
                    : t('settings.preferences.tourCosting.predefinedCost.type.fixed')
                }}</nz-tag>
              </div>
            </div>
            <div class="my-2">
              <p>
                {{ t('settings.preferences.tourCosting.predefinedCost.value') }}:
                {{
                  pre.costCalSymbol === SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.FIXED
                    ? pre?.currency || ''
                    : ''
                }}
                {{ pre.cost | number : '1.2-2' }}
                {{
                  pre.costCalSymbol ===
                  SETTINGS.FIXED_PERCENT_SYMBOL_OBJECT.PERCENT
                    ? '%'
                    : ''
                }}
              </p>
            </div>
            <div class="flex flex-row justify-between">
              <div class="justify-center">
                <nz-tag [nzColor]="pre.active ? 'green' : 'red'">{{
                  pre.active
                    ? t('settings.preferences.tourCosting.predefinedCost.status.active')
                    : t('settings.preferences.tourCosting.predefinedCost.status.inactive')
                }}</nz-tag>
              </div>
              <div class="flex flex-row gap-2">
                <button
                  nz-button
                  nz-popconfirm
                  [nzPopconfirmTitle]="t('settings.preferences.tourCosting.predefinedCost.editConfirm')"
                  nzPopconfirmPlacement="bottom"
                  nzType="default"
                  [nzOkText]="'itineraries.modals.common.ok' | transloco"
                  [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                  (nzOnConfirm)="
                    addEditPredefinedCosting(
                      SETTINGS.PREDEFINED_COST_MODE.EDIT,
                      this.predefinedCosting,
                      i
                    )
                  "
                  (nzOnCancel)="cancel()"
                  class="flex items-center justify-center gap-2 border-[#6911D8] text-[#6911D8]">
                  <lucide-icon name="pencil" class="icon-size"></lucide-icon>
                  {{ t('common.edit') }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  nz-popconfirm
                  [nzPopconfirmTitle]="t('settings.preferences.tourCosting.predefinedCost.deleteConfirm')"
                  nzPopconfirmPlacement="bottom"
                  nzDanger
                  [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                  [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                  (nzOnConfirm)="deletePredefinedCosting(i)"
                  (nzOnCancel)="cancel()"
                  class="flex items-center justify-center gap-2">
                  <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="my-5" *ngIf="!this.havePredefinedCosting()">
          <nz-alert
            nzType="warning"
            [nzMessage]="t('settings.preferences.tourCosting.predefinedCost.warning')"
            nzShowIcon>
          </nz-alert>
        </div>
        <div class="my-5" *ngIf="this.havePredefinedCosting()">
          <nz-alert
            nzType="warning"
            [nzMessage]="t('settings.preferences.tourCosting.predefinedCost.empty')"
            nzShowIcon>
          </nz-alert>
        </div>
      </div>
      <div>
        <div>
          <h6 class="mb-3">{{ t('settings.preferences.tourCosting.markup.title') }}</h6>
          <div class="flex items-center justify-between">
            <label
              nz-checkbox
              [ngModel]="this.isMarkUpBefore"
              (ngModelChange)="onChangeIsMarkup($event)">
              {{ t('settings.preferences.tourCosting.markup.checkbox') }}
            </label>
            <button nz-button nzType="primary" (click)="updateBrand()">
              {{ t('settings.common.update') }}
            </button>
          </div>
          <nz-alert
            *ngIf="markupMessage.display"
            class="mt-4"
            [nzType]="markupMessage.type"
            [nzMessage]="markupMessage.message"
            nzShowIcon
            nzCloseable></nz-alert>
        </div>
        <div class="mt-8">
          <h6 class="mb-3">{{ t('settings.preferences.tourCosting.vat.title') }}</h6>
          <div class="flex items-center justify-between gap-5">
            <nz-input-group nzAddOnAfter="%">
              <input
                nz-input
                type="number"
                min="0"
                max="100"
                [(ngModel)]="this.accVatPercentage"
                [placeholder]="t('settings.preferences.tourCosting.vat.placeholder')" />
            </nz-input-group>
            <button nz-button nzType="primary" (click)="updateVatPercentage()">
              {{ t('settings.common.update') }}
            </button>
          </div>
          <nz-alert
            *ngIf="vatMessage.display"
            class="my-4"
            [nzType]="vatMessage.type"
            [nzMessage]="vatMessage.message"
            nzShowIcon
            nzCloseable></nz-alert>
          <div class="mt-3">
            <nz-alert
              nzType="warning"
              [nzMessage]="t('settings.preferences.tourCosting.vat.warning')"
              nzShowIcon>
            </nz-alert>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-container>
